import HomeAssociateDetail from './AssociateReportModalSupplierPage';

export default HomeAssociateDetail;
